module.exports = __webpack_public_path__ + "assets/img/title-27786398.png";